import { ROLE_LABELS } from './shared.js';

export default function UserRow({ user, isCurrent, isAdmin, theme, isInactive = false, onClick, onReactivate }: {
  user: any; isCurrent: boolean; isAdmin: boolean; theme: any; isInactive?: boolean;
  onClick: () => void; onReactivate?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 16,
        padding: '14px 0', borderBottom: `1px solid ${theme.border}`,
        cursor: 'pointer', opacity: isInactive ? 0.5 : 1,
      }}
    >
      <div style={{
        width: 36, height: 36, border: `1px solid ${theme.borderMedium}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, letterSpacing: '0.06em', color: theme.text, flexShrink: 0,
      }}>{user.initials || '??'}</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 450, fontSize: 15, color: theme.text,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {user.name}
          {isCurrent && <span style={{ fontSize: 11, color: theme.textFaint, marginLeft: 6 }}>(you)</span>}
        </div>
        <div style={{
          fontSize: 12, color: theme.textFaint, letterSpacing: '0.02em',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{user.email}</div>
      </div>

      <span style={{
        fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase',
        color: user.role === 'admin' ? theme.accent : theme.text,
        border: `1px solid ${user.role === 'admin' ? theme.accent : theme.border}`,
        padding: '3px 8px', flexShrink: 0,
      }}>{ROLE_LABELS[user.role] || user.role}</span>

      <span style={{
        fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase',
        color: theme.textFaint, width: 110, textAlign: 'right', flexShrink: 0,
      }}>{user.fonts_uploaded > 0 ? `${user.fonts_uploaded} uploads` : '—'}</span>

      {isInactive && isAdmin ? (
        <span
          onClick={e => { e.stopPropagation(); onReactivate?.(); }}
          style={{ fontSize: 12, color: theme.accent, cursor: 'pointer', textTransform: 'lowercase', width: 70, textAlign: 'right', flexShrink: 0 }}
        >reactivate</span>
      ) : (
        <span style={{ fontSize: 12, color: theme.accent, textTransform: 'lowercase', width: 70, textAlign: 'right', flexShrink: 0 }}>
          {isAdmin ? 'edit' : 'view'}
        </span>
      )}
    </div>
  );
}
